import React, { useState, type FC } from 'react';
import Container from '../container';
import { Grid, Paragraph } from '../UIKit/system';
import Title from '../title';
import styled, { css } from 'styled-components';
import Button from '../button';
import Accordion from '../accordion';
import mq from '../../utils/mq';

export interface CategoryTabbedContentProps {
  title?: string;
  subtitle?: string;
  tabs: {
    _uid: string;
    name: string;
    content: {
      items: {
        _uid: string;
        title: string;
        text: { [key: string]: any };
      }[];
    }[];
  }[];
}

export const CategoryTabbedContent: FC<CategoryTabbedContentProps> = (
  props
) => {
  const { title, subtitle, tabs } = props;
  const [selected, setSelected] = useState(tabs[0]._uid);
  const mappedTabs = tabs
    .map((tab) => ({
      id: tab._uid,
      data: tab.content[0]?.items.map((faq) => ({
        question: faq.title,
        answer: faq.text
      }))
    }))
    .filter((tab) => !!tab.data);

  return (
    <Container large py={[48, 96]}>
      <Grid
        gridAutoFlow={['row', 'column']}
        gridTemplateColumns={[undefined, 'auto 1fr']}
        gridGap={[10, 99]}
      >
        <Grid width={['auto', 180]} alignContent="start">
          {title && (
            <Title as="h2" fontSizeSmall>
              {title}
            </Title>
          )}
          {subtitle && (
            <Paragraph grey fontSizeExtraSmall mt={8}>
              {subtitle}
            </Paragraph>
          )}
          <StyledList>
            {tabs.map((tab) => (
              <li key={tab._uid} role="presentation">
                <Button
                  role="listitem"
                  to="#"
                  onClick={(event) => {
                    event.preventDefault();
                    setSelected(tab._uid);
                  }}
                  display="inline-grid"
                  aria-selected={selected === tab._uid ? 'true' : undefined}
                  primaryTransparent={selected === tab._uid}
                  greyTransparent
                  height={46}
                >
                  {tab.name}
                </Button>
              </li>
            ))}
          </StyledList>
        </Grid>
        <div>
          {mappedTabs.map((tab) => (
            <StyledTabContent key={tab.id} show={selected === tab.id}>
              <Accordion metaId={tab.id} data={tab.data} />
            </StyledTabContent>
          ))}
        </div>
      </Grid>
    </Container>
  );
};

const StyledList = styled.ul`
  padding-top: 40px;
  list-style: none;

  ${mq.mobile(css`
    padding-top: 20px;
  `)}
`;

interface StyledTabContentProps {
  show?: boolean;
}

const StyledTabContent = styled.div<StyledTabContentProps>`
  display: none;

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}
`;
